import Api,{axiosRequest} from "config/Api";

export const load                   = async(json) => axiosRequest("장비 조회",'post',Api.DeviceLoad,json);
export const save                   = async(json) => axiosRequest("장비 추가",'post',Api.DeviceSave,json);
export const modify                 = async(json) => axiosRequest("장비 수정",'put',Api.DeviceModify,json);
export const handleActive           = async(json) => axiosRequest("장비 비/활성화",'put',Api.DeviceDelete,json);
export const devDelPer              = async(imei) => axiosRequest("장비 영구 삭제",'delete',Api.DeviceDelete+"/"+imei);
export const devicesList            = async() => axiosRequest("장비 목록 조회 ",'get',Api.DevicesList);
export const searchManagement       = async(json) => axiosRequest("장비 관리 페이지 검색",'post',Api.DeviceSearchM,json);
export const searchStatus           = async(json) => axiosRequest("장비 현황 페이지 검색",'post',Api.DeviceSearchS,json);
export const devMng                 = async(json) => axiosRequest("관리자-장비 매칭 관리",'post',Api.DevicesMng,json);
export const alarmHistory           = async(json) => axiosRequest("장비현황 이력 조회",'post',Api.AlarmHistory,json);
export const alarmhistoryTotalNum   = async(imei) => axiosRequest("장비 이벤트 개수 조회",'get',Api.alarmhistoryTotalNum+"/"+imei);
export const statusCount            = async() => axiosRequest("메인 페이지 : 통신이상, 이벤트 발생 장비 카운트 조회",'get',Api.StatusCount);
export const monthlyEvt             = async() => axiosRequest("메인 페이지 : 월별 이벤트 발생 차트",'get',Api.MonthlyEvt);


export default load;
